export type PeriodPreset = 'today' | 'yesterday' | 'week' | 'month';

export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export type BillingPlan = {
  credits: number;
  titleKey: string;
  benefit?: number;
  pricePerUnit: number;
  oldPricePerUnit?: number;
  total: number;
};

const ruPlans: BillingPlan[] = [
  {
    credits: 250,
    titleKey: 'plans.ideal',
    pricePerUnit: 29,
    total: 7250,
  },
  {
    credits: 500,
    titleKey: 'plans.benefit',
    benefit: 500,
    pricePerUnit: 28,
    oldPricePerUnit: 29,
    total: 14000,
  },
  {
    credits: 1000,
    titleKey: 'plans.benefit',
    benefit: 2000,
    pricePerUnit: 27,
    oldPricePerUnit: 29,
    total: 27000,
  },
  {
    credits: 2500,
    titleKey: 'plans.benefit',
    benefit: 7500,
    pricePerUnit: 26,
    oldPricePerUnit: 29,
    total: 65000,
  },
  {
    credits: 5000,
    titleKey: 'plans.benefit',
    benefit: 20000,
    pricePerUnit: 25,
    oldPricePerUnit: 29,
    total: 125000,
  },
];

const enPlans: BillingPlan[] = [
  {
    credits: 250,
    titleKey: 'plans.ideal',
    pricePerUnit: 0.32,
    total: 80,
  },
  {
    credits: 500,
    titleKey: 'plans.benefit',
    benefit: 6,
    pricePerUnit: 0.31,
    oldPricePerUnit: 0.32,
    total: 155,
  },
  {
    credits: 1000,
    titleKey: 'plans.benefit',
    benefit: 22,
    pricePerUnit: 0.3,
    oldPricePerUnit: 0.32,
    total: 300,
  },
  {
    credits: 2500,
    titleKey: 'plans.benefit',
    benefit: 83,
    pricePerUnit: 0.29,
    oldPricePerUnit: 0.32,
    total: 720,
  },
  {
    credits: 5000,
    titleKey: 'plans.benefit',
    benefit: 222,
    pricePerUnit: 0.28,
    oldPricePerUnit: 0.32,
    total: 1390,
  },
];

export const getPlans = (language: string): BillingPlan[] => {
  if (language.startsWith('en')) {
    return enPlans;
  }

  return ruPlans;
};

export const statusMeta = {
  success: { labelKey: 'history.status.success', color: '#52C41A' },
  pending: { labelKey: 'history.status.pending', color: '#8C8C8C' },
  rejected: { labelKey: 'history.status.rejected', color: '#FF4D4F' },
} as const;

export type HistoryStatus = keyof typeof statusMeta;

export const historyRows: Array<{
  id: number;
  amount: number;
  pack: number;
  date: string;
  methodKey: string;
  status: HistoryStatus;
}> = [
  {
    id: 1,
    amount: 125000,
    pack: 5000,
    date: '01.01.2026, 10:00',
    methodKey: 'history.methods.invoice',
    status: 'success',
  },
  {
    id: 2,
    amount: 7250,
    pack: 250,
    date: '01.01.2026, 10:00',
    methodKey: 'history.methods.sbp',
    status: 'success',
  },
  {
    id: 3,
    amount: 240000,
    pack: 10000,
    date: '01.01.2026, 10:00',
    methodKey: 'history.methods.card',
    status: 'pending',
  },
  {
    id: 4,
    amount: 14000,
    pack: 500,
    date: '01.01.2026, 10:00',
    methodKey: 'history.methods.card',
    status: 'rejected',
  },
];
